import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-black px-6 text-center text-white">
      <Helmet>
        <title>Page Not Found - Pagent</title>
        {/* Tell search engines not to index dead URLs (the SPA serves every
            path with HTTP 200, so without this Google indexes soft 404s). */}
        <meta name="robots" content="noindex" />
      </Helmet>

      <p className="text-6xl font-bold text-yellow-400">404</p>
      <h1 className="mt-4 text-2xl font-semibold">Page not found</h1>
      <p className="mt-2 max-w-md text-white/60">
        The page you&apos;re looking for doesn&apos;t exist or has moved.
      </p>
      <Link
        to="/"
        className="mt-8 rounded-full bg-yellow-400 px-6 py-3 font-semibold text-black transition hover:bg-yellow-300"
      >
        Back home
      </Link>
    </div>
  );
};

export default NotFound;
